import { useQuery } from '@apollo/client/react';

import { GET_PRODUCT_OPTION_QUERY } from '../../queries/query.gql';
import { Maybe, ProductOption, RootQuery } from '../../../../types/__codegen__/sanity/graphql';

type UseGetAddOnData = {
  addOn: Maybe<string> | undefined;
  shouldSkip: boolean;
};

const useGetAddOnData = ({ addOn, shouldSkip }: UseGetAddOnData) => {
  const { data, error, loading } = useQuery<RootQuery>(GET_PRODUCT_OPTION_QUERY, {
    skip: shouldSkip || !addOn,
    variables: { id: addOn },
  });

  return {
    data: data?.allProductOption[0] as ProductOption,
    hasError: !!error,
    isLoading: loading,
  };
};

export default useGetAddOnData;
